import { render, staticRenderFns } from "./index.vue?vue&type=template&id=473fb692&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473fb692')) {
      api.createRecord('473fb692', component.options)
    } else {
      api.reload('473fb692', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=473fb692&", function () {
      api.rerender('473fb692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/second/index.vue"
export default component.exports